export default __webpack_public_path__ + "static/media/image 11.b0425f5c72a8a93a14ceeee6f6d6e7e9.svg";